"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

var _react = _interopRequireWildcard(require("react"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

require("./thread.scss");

var _clientWebsocketManager = _interopRequireDefault(require("../../redux/clientWebsocketManager"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ComposeMessage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      input: ''
    };

    this.handleChange = event => {
      event.preventDefault();

      if (!event || !event.target) {
        return '';
      }

      const input = event.target.value;
      this.setState({
        input
      });
    };

    this.handleKeyPress = evt => {
      console.log(evt.code, evt.ctrlKey);

      if (evt.code === 'Enter') {
        if (!evt.ctrlKey && !evt.shiftKey) {
          this.handleSubmit();
        } else {
          const {
            input
          } = this.state;
          this.setState({
            input: `${input}\n`
          });
        }

        evt.preventDefault();
      }
    };

    this.handleSubmit = event => {
      if (event) event.preventDefault();
      const trimmedInput = this.state.input.trim();
      const isEmptyMessage = trimmedInput === '' || trimmedInput === '>' || trimmedInput === '``````' || trimmedInput === '``' || trimmedInput === '**' || trimmedInput === '____' || trimmedInput === '__' || trimmedInput === '****';

      if (isEmptyMessage) {
        return;
      }

      const {
        input
      } = this.state;
      const {
        sendMessage,
        getMessages
      } = this.props;

      if (input.length > 0 && /\S/.test(input)) {
        sendMessage(input);
        getMessages();
        this.setState({
          input: ''
        });
      }
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      threadId
    } = this.props;
    const {
      input
    } = this.state;

    if (input !== '' && input !== prevState.input) {
      _clientWebsocketManager.default.sendTypingIndicator(threadId);
    } else if (prevState.input !== '' && input === '') {
      _clientWebsocketManager.default.sendNotTypingIndicator(threadId);
    }
  }

  render() {
    const {
      input
    } = this.state;
    const {
      isTypingIndicators,
      threadId
    } = this.props;
    const typingIndicators = isTypingIndicators && threadId && isTypingIndicators.get(threadId) ? Array.from(isTypingIndicators.get(threadId)) : [];
    let typingStr;

    if (typingIndicators.length === 1) {
      typingStr = `${typingIndicators[0]} is typing`;
    } else if (typingIndicators.length === 2) {
      typingStr = `${typingIndicators[0]} and ${typingIndicators[1]} are typing`;
    } else if (typingIndicators.length > 2) {
      typingStr = `${typingIndicators[0]}, ${typingIndicators[1]} and more are typing`;
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "compose-message"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "compose-message-container"
    }, /*#__PURE__*/_react.default.createElement(_reactTextareaAutosize.default, {
      spellCheck: true,
      maxRows: 3,
      onChange: this.handleChange,
      onKeyPress: this.handleKeyPress,
      value: input,
      placeholder: "ENTER to send.  Control-ENTER or Shift-ENTER for new line.",
      className: "compose-message-input"
    }), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this.handleSubmit
    }, "Send")), /*#__PURE__*/_react.default.createElement("div", {
      className: "typing-indicator"
    }, typingStr, !!typingStr && /*#__PURE__*/_react.default.createElement("span", null, "\u00A0", /*#__PURE__*/_react.default.createElement("span", {
      className: "loader__dot"
    }, "."), /*#__PURE__*/_react.default.createElement("span", {
      className: "loader__dot"
    }, "."), /*#__PURE__*/_react.default.createElement("span", {
      className: "loader__dot"
    }, "."))));
  }

}

var _default = ComposeMessage;
exports.default = _default;